<template>
  <div
    :class="[
      'db-tw-mt-5 db-tw-mb-8',
      {
        'db-has-error': v$.field.$error,
      },
    ]"
  >
    <label class="db-label">
      <span>
        {{ labelAddEvent }}
        <span
          v-if="isMandatory"
          class="db-input-required-indicator"
        >
          *
        </span>
      </span>
    </label>
    <div>
      <div
        class="db-checks db-tw-flex db-tw-flex-wrap db-tw-mt-3 db-tw-mb-2 db-tw-py-6 db-tw-px-4 db-tw-border db-tw-border-solid db-tw-border-form-border"
      >
        <div
          v-for="(event, j) in events"
          :key="j"
          :class="[
            'db-tw-flex-[100%] md:db-tw-flex-[50%]',
            { 'md:db-tw-mb-8': j < events.length - 2 },
            { 'db-tw-mb-8 md:db-tw-mb-0': j < events.length - 1 },
          ]"
        >
          <DbCheckbox
            :modelValue="modelValue"
            :inputAttrs="{
              value: events[j].name,
              name: 'event',
            }"
            v-on:update:model-value="$emit('update:modelValue', $event)"
          >
            {{ event.name }}
          </DbCheckbox>
        </div>
      </div>
      <div
        v-if="v$.field.$error"
        class="db-label"
      >
        <DbRfpErrors :errors="v$.field.$errors" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useVuelidate } from '@vuelidate/core'
import { requiredIf } from '@/utils/i18n-validators'

const props = withDefaults(
  defineProps<{
    modelValue?: string[]
    labelAddEvent: string
    events: { name: string }[]
    isMandatory: boolean
  }>(),
  {
    modelValue: () => [],
  },
)

defineEmits<{
  (e: 'update:modelValue', modelValue: string[]): void
}>()

const state = computed(() => {
  return {
    field: props.modelValue,
  }
})

const rules = computed(() => {
  return {
    field: { required: requiredIf(props.isMandatory) },
  }
})

const v$ = useVuelidate(rules, state, { $autoDirty: true })
</script>

<style scoped>
/*
  * Change border color on error
*/
.db-app .db-has-error .db-checks {
  @apply db-tw-border-form-error-border;
}
</style>
